// import { call, put, takeLatest } from "redux-saga/effects";
// import {
//   fetchTimesheets,
//   fetchOneTimesheet,
//   addTimesheet,
//   updateTimesheet,
//   fetchTimesheetsPlacements,
// } from "./timesheetApi";

// import {
//   getTimesheetsStart,
//   getTimesheetsSuccess,
//   getTimesheetsFailure,
//   getTimesheetOneStart,
//   getTimesheetOneSuccess,
//   getTimesheetOneFailure,
//   addTimesheetStart,
//   addTimesheetSuccess,
//   addTimesheetFailure,
//   updateTimesheetStart,
//   updateTimesheetSuccess,
//   updateTimesheetFailure,
//   getTimeSheetsDashboardStart,
//   successTimeSheetsDasboardStart,
// } from "./timsheetSlice";

// import { showToast } from "../../../components";

// function* fetchTimesheetsSaga(action) {
//   try {
//     const response = yield call(fetchTimesheets, action.payload);
//     yield put(getTimesheetsSuccess(response));
//   } catch (error) {
//     yield put(getTimesheetsFailure(error.message));
//   }
// }

// function* fetchOneTimesheetSaga(action) {
//   const { onSuccess, ...payload } = action.payload;
//   try {
//     const response = yield call(fetchOneTimesheet, payload);
//     yield put(getTimesheetOneSuccess(response.data));
//     try {
//       onSuccess?.();
//     } catch (err) {
//       console.error("onSuccess threw an error", err);
//     }
//   } catch (error) {
//     yield put(getTimesheetOneFailure(error.message));
//   }
// }

// function* addTimesheetSaga(action) {
//   try {
//     const { onSuccess, ...payload } = action.payload;
//     const response = yield call(addTimesheet, payload);
//     if (response.success) {
//       yield put(addTimesheetSuccess(response.data));
//       onSuccess(response.data);
//       showToast("Timesheet added successfully", "success", 3000);
//     } else {
//       yield put(addTimesheetFailure(response.error));
//       showToast(`${response.error}`, "error", 3000);
//     }
//   } catch (error) {
//     console.log("error from saga", error);
//     yield put(addTimesheetFailure(error.message));
//     showToast("Failed to add timesheet", "error", 3000);
//   }
// }

// function* updateTimesheetSaga(action) {
//   try {
//     const { onSuccess, ...payload } = action.payload;
//     const response = yield call(updateTimesheet, payload);
//     if (response.success) {
//       yield put(updateTimesheetSuccess(response.data));
//       onSuccess(response.data);
//       showToast("Timesheet updated successfully", "success", 3000);
//     } else {
//       yield put(updateTimesheetFailure(response.error));
//       showToast(`${response.error}`, "error", 3000);
//     }
//   } catch (error) {
//     yield put(updateTimesheetFailure(error.message));
//     showToast("Failed to update timesheet", "error", 3000);
//   }
// }
// function* fetchTimeSheetPlacements(action) {
//   try {
//     const response = yield call(fetchTimesheetsPlacements, action.payload);
//     if (response.success) {
//       yield put(successTimeSheetsDasboardStart(response));
//     } else {
//       yield put(successTimeSheetsDasboardStart({}));
//     }
//     // yield put(getTimesheetsSuccess(response));
//   } catch (error) {
//     yield put(successTimeSheetsDasboardStart({}));
//     // yield put(getTimesheetsFailure(error.message));
//   }
// }

// export function* watchTimesheets() {
//   yield takeLatest(getTimesheetsStart.type, fetchTimesheetsSaga);
//   yield takeLatest(getTimesheetOneStart.type, fetchOneTimesheetSaga);
//   yield takeLatest(addTimesheetStart.type, addTimesheetSaga);
//   yield takeLatest(updateTimesheetStart.type, updateTimesheetSaga);
//   yield takeLatest(getTimeSheetsDashboardStart, fetchTimeSheetPlacements);
// }

import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTimesheets,
  fetchOneTimesheet,
  addTimesheet,
  updateTimesheet,
  fetchTimesheetsPlacements,
} from "./timesheetApi";

import {
  getTimesheetsStart,
  getTimesheetsSuccess,
  getTimesheetsFailure,
  getTimesheetOneStart,
  getTimesheetOneSuccess,
  getTimesheetOneFailure,
  addTimesheetStart,
  addTimesheetSuccess,
  addTimesheetFailure,
  updateTimesheetStart,
  updateTimesheetSuccess,
  updateTimesheetFailure,
  getTimeSheetsDashboardStart,
  successTimeSheetsDasboardStart,
  failureTimeSheetsDasboardStart,
} from "./timsheetSlice";

import { showToast } from "../../../components";

function* fetchTimesheetsSaga(action) {
  try {
    const response = yield call(fetchTimesheets, action.payload);
    yield put(getTimesheetsSuccess(response));
  } catch (error) {
    yield put(getTimesheetsFailure(error.message));
  }
}

function* fetchOneTimesheetSaga(action) {
  const { onSuccess, ...payload } = action.payload;
  try {
    const response = yield call(fetchOneTimesheet, payload);
    yield put(getTimesheetOneSuccess(response.data));
    try {
      onSuccess?.();
    } catch (err) {
      console.error("onSuccess threw an error", err);
    }
  } catch (error) {
    yield put(getTimesheetOneFailure(error.message));
  }
}

function* addTimesheetSaga(action) {
  try {
    const { onSuccess, ...payload } = action.payload;
    const response = yield call(addTimesheet, payload);
    if (response.success) {
      yield put(addTimesheetSuccess(response.data));
      onSuccess(response.data);
      showToast("Timesheet added successfully", "success", 3000);
    } else {
      yield put(addTimesheetFailure(response.error));
      showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    console.log("error from saga", error);
    yield put(addTimesheetFailure(error.message));
    showToast("Failed to add timesheet", "error", 3000);
  }
}

function* updateTimesheetSaga(action) {
  try {
    const { onSuccess, supressToast = false,...payload } = action.payload;
    const response = yield call(updateTimesheet, payload);
    if (response.success) {
      yield put(updateTimesheetSuccess(response.data));
      onSuccess(response.data);
      if (!supressToast) {
        showToast("Timesheet updated successfully", "success", 3000);
      }
    } else {
      yield put(updateTimesheetFailure(response.error));
      showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    yield put(updateTimesheetFailure(error.message));
    showToast("Failed to update timesheet", "error", 3000);
  }
}
function* fetchTimeSheetPlacements(action) {
  try {
    const response = yield call(fetchTimesheetsPlacements, action.payload);
    if (response.success) {
      yield put(successTimeSheetsDasboardStart(response));
    } else {
      yield put(failureTimeSheetsDasboardStart({}));
    }
    // yield put(getTimesheetsSuccess(response));
  } catch (error) {
    yield put(failureTimeSheetsDasboardStart({}));
    // yield put(getTimesheetsFailure(error.message));
  }
}

export function* watchTimesheets() {
  yield takeLatest(getTimesheetsStart.type, fetchTimesheetsSaga);
  yield takeLatest(getTimesheetOneStart.type, fetchOneTimesheetSaga);
  yield takeLatest(addTimesheetStart.type, addTimesheetSaga);
  yield takeLatest(updateTimesheetStart.type, updateTimesheetSaga);
  yield takeLatest(getTimeSheetsDashboardStart, fetchTimeSheetPlacements);
}
